// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"814":"17867593","1021":"b7cbf4c9","1856":"376bbb15","5901":"31d6cfe0","7296":"b1f8dc6f"}[chunkId] + ".chunk.css";
};